export default "__VITE_ASSET__Dx5Mm7aQ__"